import type { TOC } from '@ember/component/template-only';
import { PrismModal } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import HotelAndMarketRevenueInsightMultiPmsPortfolioDetailsTable from 'lumen/components/hotel-and-market/revenue-insight/multi-pms/portfolio-details-table';
import type MarketRevenueInsightPortfolioDetailsModalController from 'lumen/controllers/market/revenue-insight/portfolio-details-modal';

interface MarketRevenueInsightPortfolioDetailsModalSignature {
  Args: {
    controller: MarketRevenueInsightPortfolioDetailsModalController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.multi.redirectOnClose}}
    @title={{t "revenue_insight.multi_pms.modal_portfolio_details.heading"}}
  >
    <:default>
      <div class="modal--stretched">
        <HotelAndMarketRevenueInsightMultiPmsPortfolioDetailsTable
          @isLoading={{@controller.multi.isModelLoading}}
          {{! @glint-expect-error: Incorrect type }}
          @model={{@controller.multi.sortedSegmentationHotels.sortedSegmentationObjects}}
        />
      </div>
    </:default>
    <:footer>
      <div
        class="portfolio-details-modal-footer ml-500 flex items-center justify-start"
      >
        <GeneralNavigationIntercomHelpLink
          @articleLink="en/articles/5592427-choosing-your-kpi-display-in-revenue-insight"
          @linkText={{t
            "settings.pms_mapping.modal_kpi_display_saved_changes.find_out_more"
          }}
          @type="text"
        />
      </div>
    </:footer>
  </PrismModal>
</template> satisfies TOC<MarketRevenueInsightPortfolioDetailsModalSignature>;
